export namespace MouseEventDispatcher {

    import MouseEvent = createjs.MouseEvent;

    let targetedObj: any;

    const jsEventType = {
        wheel: "wheel"
    };

    const jsToAS3eventsMapping: { [key: string]: string | undefined } = {
        wheel: MouseEvent.MOUSE_WHEEL
    };

    export function setTarget(target: any) {
        targetedObj = target;
    }

    export function init() {
        window.addEventListener(jsEventType.wheel, eventHandler);
    }

    function convertEvent(event: any): MouseEvent {
        const newEventEventType = jsToAS3eventsMapping[event.type];
        if (!newEventEventType) {
            throw new Error(`Can't convert event of type "${event.type}"`);
        }

        const result: MouseEvent = new MouseEvent(newEventEventType, event.bubbles, event.cancelable);

        result.ctrlKey = event.ctrlKey;
        result.altKey = event.altKey;
        result.shiftKey = event.shiftKey;
        result.target = event.target;
        result.nativeEvent = event;

        return result;
    }

    const eventHandler: (event: WheelEvent) => void = function (event) {
        let t = targetedObj;
        while (t) {
            if (t.hasEventListener(MouseEvent.MOUSE_WHEEL) && t.dispatchEvent) {
                t.dispatchEvent(convertEvent(event));
                break;
            }
            t = t.parent;
        }
    };

}
